import { gql } from 'apollo-angular';
import { CommandTemplate } from '../../entities/commandTemplate/commandTemplate';


export const COMMAND_BY_NAME_QUERY = gql`
query commandByNameQuery($commandName: String)
{
  getCommand(commandName: $commandName)
}
`;

export const COMMAND_BY_COMMANDINPUT_QUERY = gql`
query commandByCommandInputQuery($commandInput: CommandInput)
{
  getCommandByCommandInput(commandInput: $commandInput)
}
`;
export interface CommandButtonQueryResponse {
  loading: boolean;
  command: CommandTemplate;
}
